import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const lifetimeElectricityConsumptionField: FieldMetadataMessageDescriptorDef =
  {
    displayName: msg({
      message: 'Lifetime electricity consumption',
      context: 'The electricity usage over the lifetime of a sold product.',
    }),
  };

export const lifetimeElectricityConsumptionUnitField: FieldMetadataMessageDescriptorDef =
  {
    displayName: msg({
      message: 'Lifetime electricity consumption unit',
      context:
        'Unit (e.g. kwh) for a column of data describing the total electricity consumption of a product in its lifetime',
    }),
    externalDescription: msg({
      message: 'The unit of lifetime electricity consumption',
      context:
        'Description for a unit (e.g. kwh) of a column of data describing the total electricity consumption of a product in its lifetime',
    }),
  };

export const electricityUsageQuantityField: FieldMetadataMessageDescriptorDef =
  {
    displayName: msg({
      message: 'Electricity usage',
      context: 'The consumption of electricity.',
    }),
    externalDescription: msg({
      message: 'The consumption of electricity.',
      context: 'Electricity usage',
    }),
  };
